export default "__VITE_ASSET__95e333fa__"